(function () {
  if (window.__rwV5CollectionLoaded) return;
  window.__rwV5CollectionLoaded = true;

  function updateAnchorOffset() {
    var headers = Array.prototype.slice.call(document.querySelectorAll('[class*="header-"], header'));
    var fixedHeader = headers.find(function (element) {
      var style = window.getComputedStyle(element);
      if (style.position !== 'fixed' && style.position !== 'sticky') return false;
      var rect = element.getBoundingClientRect();
      return rect.height > 40 && rect.top <= 4;
    });

    var offset = fixedHeader ? Math.ceil(fixedHeader.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--rw-v5-anchor-offset', offset + 'px');
  }

  function isVisibleOverlay(element) {
    if (!element) return false;

    var style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    if (element.getAttribute('aria-hidden') === 'true') return false;

    var isKnownDrawer = element.matches && element.matches(
      '#MenuDrawer, #SearchDrawer, #CartDrawer, #FacetDrawer, menu-drawer, search-drawer, cart-drawer, .drawer, .modal, .f-drawer-mobile-nav'
    );

    if (element.hasAttribute('open') ||
      element.hasAttribute('active') ||
      element.classList.contains('active') ||
      element.classList.contains('open') ||
      element.classList.contains('is-open')) {
      return true;
    }

    if (isKnownDrawer && !element.hasAttribute('hidden')) {
      var rect = element.getBoundingClientRect();
      return rect.width > 40 && rect.height > 40;
    }

    return false;
  }

  function updateMobileMenuState() {
    var overlaySelectors = [
      '#MenuDrawer',
      '#SearchDrawer',
      '#CartDrawer',
      '#FacetDrawer',
      'menu-drawer',
      'search-drawer',
      'cart-drawer',
      'drawer-component',
      'basic-modal',
      'modal-component',
      'quick-view',
      '.drawer',
      '.modal',
      '.f-drawer-mobile-nav',
      '[class*="mobile-nav"]'
    ];
    var overlayElements = Array.prototype.slice.call(document.querySelectorAll(overlaySelectors.join(',')));

    var activeElement = document.activeElement;
    var activeInsideOverlay = activeElement && activeElement.closest && activeElement.closest(overlaySelectors.join(','));

    var isOpen = document.body.classList.contains('modal-show') ||
      document.body.classList.contains('modal-showing') ||
      document.body.classList.contains('has-dropdown-menu') ||
      document.body.classList.contains('overflow-hidden') ||
      Boolean(activeInsideOverlay) ||
      overlayElements.some(isVisibleOverlay);

    document.documentElement.classList.toggle('rw-v5-mobile-menu-open', isOpen);
    document.documentElement.classList.toggle('rw-v5-overlay-open', isOpen);
    document.body.classList.toggle('rw-v5-mobile-menu-open', isOpen);
    document.body.classList.toggle('rw-v5-overlay-open', isOpen);

    Array.prototype.slice.call(document.querySelectorAll('.rw-v5-anchor-nav-section')).forEach(function (nav) {
      nav.classList.toggle('rw-v5-anchor-nav-section--hidden', isOpen);
    });
  }

  updateAnchorOffset();
  updateMobileMenuState();
  window.addEventListener('resize', updateAnchorOffset);
  window.addEventListener('scroll', updateAnchorOffset, { passive: true });
  document.addEventListener('click', function (event) {
    var menuButton = event.target && event.target.closest && event.target.closest('[class*="header-menu-burger"]');

    if (menuButton) {
      var header = menuButton.closest('[class*="header-"]');
      document.documentElement.classList.toggle(
        'rw-v5-mobile-menu-open',
        !(header && header.classList && header.classList.contains('open'))
      );
    }

    window.setTimeout(updateMobileMenuState, 40);
    window.setTimeout(updateMobileMenuState, 260);
  });
  document.addEventListener('keyup', updateMobileMenuState);
  document.addEventListener('toggle', updateMobileMenuState, true);
  document.addEventListener('drawer:handleAfterShow', updateMobileMenuState);
  document.addEventListener('drawer:handleAfterHide', updateMobileMenuState);

  if (window.MutationObserver) {
    new MutationObserver(updateMobileMenuState).observe(document.body, {
      attributes: true,
      childList: true,
      attributeFilter: ['class', 'open', 'active', 'hidden', 'aria-hidden'],
      subtree: true
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.classList || !form.classList.contains('rw-v5-card-form')) return;

    event.preventDefault();

    var button = form.querySelector('button[type="submit"]');
    var originalText = button ? button.getAttribute('data-add-text') || button.textContent : '';

    if (button) {
      button.disabled = true;
      button.textContent = 'Adding...';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function (item) {
        if (button) button.textContent = button.getAttribute('data-added-text') || 'Added';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:added', { detail: { item: item } }));
      })
      .catch(function () {
        if (button) button.textContent = 'Try again';
      })
      .finally(function () {
        window.setTimeout(function () {
          if (!button) return;
          button.disabled = false;
          button.textContent = originalText;
        }, 1800);
      });
  });
})();
